export const SELECT_REGISTRATION_STATION = "SELECT_REGISTRATION_STATION"

export const VERIFIED_PERSON = "VERIFIED_PERSON"
export const CLEAR_VERIFIED_PERSON = "CLEAR_VERIFIED_PERSON"